<script lang="ts" setup>
  import { Icon } from '@skillstown/leap';
  import { useDrawer } from '~~/stores/drawer';
import { useModal } from '~~/stores/modal';
import FaqModal from '@/components/Faq/Modal.vue';

  const drawer = useDrawer();
  const modal = useModal();

  const router = useRouter();
  const route = useRoute();
  const { cardPadding } = useLeapCustomizations();

  const url = window.location.href.includes('/admin') ? window.origin + '/admin' : window.origin;

  const isAdminRoute = computed(() => route.path.includes('/admin'));

  function faqNavigation(): void {
    // if (isAdminRoute.value) {
    //   router.push('/admin/faq');
    //   return;
    // }
    // router.push('/faq');
    modal.open({
      component: shallowRef(FaqModal),
    })
    drawer.close();
  }

  function onClickClose(): void {
    drawer.close();
  }
</script>

<template>
  <ModalBase
    :title="$t('help_and_support')"
    :isFullScreen="true"
    :removeFooter="true"
    :onClose="onClickClose"
  >
    <div class="grid grid-cols-1 gap-4">
      <div class="support-card">
        <h3>{{ $t('support__email_card_title') }}</h3>
        <p>
          {{ $t('support__email_card_text') }}
        </p>

        <a
          href="mailto:infotriple-a@nibesvv.nl"
          class="support-card__link"
        >
          <Icon
            icon="email"
            size="l"
            color="brand"
          />
          <span> infotriple-a@nibesvv.nl </span>
        </a>
      </div>

      <div class="support-card">
        <h3>{{ $t('support__account_manager_card_title') }}</h3>
        <p>
          {{ $t('support__account_manager_card_text') }} 
          <a
            href="mailto:infotriple-a@nibesvv.nl"
            class="support-card__link"
          > infotriple-a@nibesvv.nl </a>
        </p>
      </div>

      <div class="support-card">
        <h3>{{ $t('faq') }}</h3>
        <!-- eslint-disable vue/no-parsing-error -->
        <!-- TODO Tech Debt: You have <div> block in <p> that is inline. -->
        <p>
          {{ $t('support__faq_card_text__without_link') }}
          <div @click="faqNavigation()">
            <p class="text-brand cursor-pointer">{{ $t('support__faq_card_text___link') }}</p>
          </div>
        </p>
        <!-- eslint-enable vue/no-parsing-error -->
      </div> 
    </div>
  </ModalBase>
</template>

<style scoped lang="postcss">
  .support-card {
    @apply flex flex-col rounded-lg bg-white py-2;
    h3 {
      @apply font-bold;
    }
    p {
      @apply font-light text-sm;
    }
    strong {
      @apply text-sm font-normal;
    }
    &__link {
      @apply flex items-center gap-3 text-black;
      span {
        @apply text-sm text-black transition-all;
      }
      &:hover {
        span {
          @apply pl-1;
          color: var(--color-brand);
        }
      }
    }
  }
</style>
